// import React, { useState, useEffect } from 'react';
// import {
//     Link,
//     Typography,
//     LinearProgress, Alert, 
//     Container, Grid, Button,
//     Dialog, DialogTitle, DialogContentText, DialogContent, DialogActions
// } from '@mui/material';

// function ConfirmDialog(props) {
//     const { title, descriptions, labelOk, 
//         labelCancel, open, showLoader, 
//         showSuccess, handleUserAction,  } = props;
//     let newTitle = title;
 
//     return (
//         <Dialog
//             open={open}
//             // onClose={() => handleUserAction()}
//             aria-labelledby="alert-dialog-title"
//             aria-describedby="alert-dialog-description"
//         >
//             {!showLoader && !showSuccess && <>
//             <DialogTitle id="alert-dialog-title">
//                 {!title && "Are you sure about this action?"}
//                 {title && newTitle}
//             </DialogTitle>
//             <DialogContent>
//                 <DialogContentText id="alert-dialog-description">
//                     {!descriptions && "Do this only if you prety sure about impacts of this action."}
//                     {descriptions && descriptions}
//                 </DialogContentText>
//             </DialogContent>
//             <DialogActions sx={{pr:3}}>
//                 <Button variant='outlined' color='info' onClick={() => handleUserAction('disagree')}>
//                     {labelCancel && labelCancel}
//                     {!labelCancel && "Cancel"}
//                 </Button>
//                 <Button variant='outlined' color='warning' onClick={() => handleUserAction('agree')} autoFocus>
//                     {labelOk && labelOk}
//                     {!labelOk && "Agree"}
//                 </Button>
//             </DialogActions>
//             </>}
//         </Dialog>
//     )
// }
// export default ConfirmDialog



import React from "react";
import {
    Dialog,
    DialogContent,
    DialogActions,
    Typography,
    Button,
    IconButton,
    Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import "./style.css";

function ConfirmDialog(props) {
    const { title, descriptions, labelOk,
        labelCancel, open, showLoader,
        showSuccess, handleUserAction, } = props;
    let newTitle = title;

    return (
        <Dialog
            open={open}
            onClose={() => handleUserAction()}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            PaperProps={{ className: "confirm-dialog-paper" }}
        >
            {/* Close button */}
            <IconButton
                aria-label="close"
                onClick={() => handleUserAction()}
                className="confirm-dialog-close"
            >
                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.85372 9.14622C9.90018 9.19268 9.93703 9.24783 9.96217 9.30853C9.98731 9.36922 10.0003 9.43428 10.0003 9.49997C10.0003 9.56567 9.98731 9.63072 9.96217 9.69142C9.93703 9.75212 9.90018 9.80727 9.85372 9.85372C9.80727 9.90018 9.75212 9.93703 9.69142 9.96217C9.63072 9.98731 9.56567 10.0003 9.49997 10.0003C9.43428 10.0003 9.36922 9.98731 9.30853 9.96217C9.24783 9.93703 9.19268 9.90018 9.14622 9.85372L4.99997 5.70685L0.853723 9.85372C0.759902 9.94754 0.632655 10.0003 0.499973 10.0003C0.367291 10.0003 0.240043 9.94754 0.146223 9.85372C0.0524025 9.7599 -0.000305173 9.63266 -0.000305176 9.49997C-0.000305178 9.36729 0.0524025 9.24004 0.146223 9.14622L4.2931 4.99997L0.146223 0.853723C0.0524025 0.759902 -0.000305176 0.632655 -0.000305176 0.499973C-0.000305176 0.367291 0.0524025 0.240043 0.146223 0.146223C0.240043 0.0524025 0.367291 -0.000305176 0.499973 -0.000305176C0.632655 -0.000305176 0.759902 0.0524025 0.853723 0.146223L4.99997 4.2931L9.14622 0.146223C9.24004 0.0524025 9.36729 -0.000305178 9.49997 -0.000305176C9.63266 -0.000305173 9.7599 0.0524025 9.85372 0.146223C9.94754 0.240043 10.0003 0.367291 10.0003 0.499973C10.0003 0.632655 9.94754 0.759902 9.85372 0.853723L5.70685 4.99997L9.85372 9.14622Z" fill="#606060" />
                </svg>
            </IconButton>

            <DialogContent className="confirm-dialog-content">
                {/* Warning Icon */}
                <svg className="confirm-dialog-icon" width="43" height="32" viewBox="0 0 43 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M27 0.875C24.191 0.877156 21.438 1.6607 19.0489 3.13801C16.6598 4.61531 14.7287 6.72813 13.4717 9.24016C11.9763 9.02207 10.452 9.11444 8.99393 9.51151C7.53583 9.90858 6.17518 10.6018 4.99686 11.548C3.81854 12.4942 2.84782 13.6731 2.14525 15.011C1.44269 16.349 1.02334 17.8174 0.913378 19.3246C0.803413 20.8318 1.00519 22.3455 1.50611 23.7712C2.00704 25.197 2.79637 26.5042 3.82487 27.6115C4.85337 28.7187 6.09899 29.6021 7.48402 30.2066C8.86904 30.8111 10.3638 31.1237 11.875 31.125H27C31.0114 31.125 34.8585 29.5315 37.695 26.695C40.5315 23.8585 42.125 20.0114 42.125 16C42.125 11.9886 40.5315 8.1415 37.695 5.30501C34.8585 2.46852 31.0114 0.875 27 0.875ZM27 28.375H11.875C9.68694 28.375 7.58852 27.5058 6.04135 25.9586C4.49417 24.4115 3.62498 22.313 3.62498 20.125C3.62498 17.937 4.49417 15.8385 6.04135 14.2914C7.58852 12.7442 9.68694 11.875 11.875 11.875C12.064 11.875 12.2531 11.875 12.4404 11.8939C12.0644 13.2302 11.8741 14.6118 11.875 16C11.875 16.3647 12.0198 16.7144 12.2777 16.9723C12.5356 17.2301 12.8853 17.375 13.25 17.375C13.6147 17.375 13.9644 17.2301 14.2222 16.9723C14.4801 16.7144 14.625 16.3647 14.625 16C14.625 13.5525 15.3508 11.1599 16.7105 9.12482C18.0703 7.08976 20.003 5.50363 22.2643 4.56699C24.5255 3.63036 27.0137 3.38529 29.4142 3.86278C31.8147 4.34027 34.0197 5.51888 35.7504 7.24955C37.4811 8.98023 38.6597 11.1852 39.1372 13.5858C39.6147 15.9863 39.3696 18.4745 38.433 20.7357C37.4964 22.9969 35.9102 24.9297 33.8752 26.2894C31.8401 27.6492 29.4475 28.375 27 28.375ZM25.625 16V9.125C25.625 8.76033 25.7698 8.41059 26.0277 8.15273C26.2856 7.89487 26.6353 7.75 27 7.75C27.3647 7.75 27.7144 7.89487 27.9723 8.15273C28.2301 8.41059 28.375 8.76033 28.375 9.125V16C28.375 16.3647 28.2301 16.7144 27.9723 16.9723C27.7144 17.2301 27.3647 17.375 27 17.375C26.6353 17.375 26.2856 17.2301 26.0277 16.9723C25.7698 16.7144 25.625 16.3647 25.625 16ZM29.0625 22.1875C29.0625 22.5954 28.9415 22.9942 28.7149 23.3334C28.4883 23.6725 28.1661 23.9369 27.7893 24.093C27.4124 24.2491 26.9977 24.29 26.5976 24.2104C26.1975 24.1308 25.83 23.9344 25.5416 23.6459C25.2531 23.3575 25.0567 22.99 24.9771 22.5899C24.8975 22.1898 24.9384 21.7751 25.0945 21.3982C25.2506 21.0213 25.5149 20.6992 25.8541 20.4726C26.1933 20.246 26.5921 20.125 27 20.125C27.547 20.125 28.0716 20.3423 28.4584 20.7291C28.8452 21.1159 29.0625 21.6405 29.0625 22.1875Z" fill="#E03131" />
                </svg>

                {/* Message */}
                <Typography className="confirm-dialog-message">
                    Are You Sure You Want to Switch to <b>{title}</b>? {" "+ descriptions}
                </Typography>

                {/* Action Buttons */}
                <Box className="confirm-dialog-actions">
                    <Button
                        variant="outlined"
                        className="confirm-dialog-btn cancel"
                        onClick={() => handleUserAction('agree')}
                    >
                        Switch Property
                    </Button>

                    {/* <Button
                        variant="contained"
                        className="confirm-dialog-btn save"
                        onClick={() => handleUserAction('review')}
                    >
                        Review and Update
                    </Button> */}
                    <Button
                        variant="contained"
                        className="confirm-dialog-btn save"
                        onClick={() => handleUserAction('disagree')} // LRV-2072
                    >
                        Cancel
                    </Button>
                </Box>
            </DialogContent>

        </Dialog>
    );
}

export default ConfirmDialog;


